import { _ as T } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { ThemeName as mt, BREAKPOINTS as H } from "@ucl/shared-component-foundations";
import { c as n } from "./index-8b07dec9.js";
import { forwardRef as st, useRef as lt, useMemo as pt } from "react";
import d, { styled as dt, css as l, useTheme as ct } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as R } from "./cloneSlots-622cf8c9.js";
import { c as ut } from "./combineRefs-c9ad2c39.js";
import { g as gt } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSize as vt } from "./useSize.js";
import { useSlots as ht } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { e as A, f as E } from "./index-f5b44da3.js";
import { _ as _t } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import { Hero as Ct } from "./hero.js";
import { jsx as m, jsxs as z } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "./es.string.iterator-5de8a61e.js";
import "./index-5d0f31c6.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-icons";
import "@ucl/ucl-translation";
import "react-dom";
import "./aria.js";
import "./useWindowSize.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./button.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var Tt = ["showPlayButton", "className"], V, f = dt(Ct)(V || (V = _t([`
  &.Card__Media {
    `, `;
  }
`])), function(r) {
  var t = r.theme.components.card;
  return l(t.Media);
}), h = function(t) {
  var e = t.showPlayButton, i = t.className, s = T(t, Tt);
  return /* @__PURE__ */ m(f, Object.assign({
    showPlaybackButton: e,
    className: n(["Card__Media", i])
  }, s, {
    hideOverlay: !0
  }));
};
h.Image = f.Image;
h.Video = f.Video;
h.PlayBackButton = f.PlaybackButton;
h.DisclosureButton = f.DisclosureButton;
var ft = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__FlexContainer",
  componentId: "sc-1ocr13b-0"
})(["&.CardGroupContainer{", ";}"], function(r) {
  var t = r.theme.components.card;
  return l(t.CardGroupContainer);
}), yt = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__Container",
  componentId: "sc-1ocr13b-1"
})(["&.Card__container{", ";}"], function(r) {
  var t = r.theme, e = t.components.card, i = t.componentStyles;
  return l(e.Container, i);
}), Nt = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__Card",
  componentId: "sc-1ocr13b-2"
})(["&.Card{", ";}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Card);
}), bt = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__Content",
  componentId: "sc-1ocr13b-3"
})(["&.Card__content{", ";}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Content);
}), $t = /* @__PURE__ */ d.h1.withConfig({
  displayName: "cardstyles__Title",
  componentId: "sc-1ocr13b-4"
})(["&.Card__title{", ";}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Title);
}), Lt = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__Subtitle",
  componentId: "sc-1ocr13b-5"
})(["&.Card__subtitle{", ";}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Subtitle);
}), Ft = /* @__PURE__ */ d.div.withConfig({
  displayName: "cardstyles__Body",
  componentId: "sc-1ocr13b-6"
})(["&.Card__body{", "}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Body);
}), Mt = /* @__PURE__ */ d.footer.withConfig({
  displayName: "cardstyles__Footer",
  componentId: "sc-1ocr13b-7"
})(["&.Card__footer{", "}"], function(r) {
  var t = r.theme.components.card;
  return l(t.Footer);
}), jt = ["className", "style", "gap", "alignItems", "justifyContent", "margin", "padding"], Gt = ["headingLevel", "size", "className"], It = ["headingLevel", "className"], Ot = function(t) {
  var e = t.className, i = t.style, s = i === void 0 ? {} : i, p = t.gap, c = t.alignItems, u = t.justifyContent, g = t.margin, y = t.padding, v = T(t, jt);
  return /* @__PURE__ */ m(ft, Object.assign({
    className: n(["CardGroupContainer", e]),
    style: Object.assign({}, s, {
      gap: p,
      alignItems: c,
      justifyContent: u,
      margin: g,
      padding: y
    })
  }, v));
}, k = function(t) {
  var e = t.headingLevel, i = e === void 0 ? "h1" : e, s = t.size, p = s === void 0 ? "extraLarge" : s, c = t.className, u = T(t, Gt);
  return /* @__PURE__ */ m($t, Object.assign({
    as: i,
    className: n("Card__title", "Card__title--" + p, c)
  }, u));
}, Bt = function(t) {
  var e = t.headingLevel, i = e === void 0 ? "h2" : e, s = t.className, p = T(t, It);
  return /* @__PURE__ */ m(Lt, Object.assign({
    as: i,
    className: n("Card__subtitle", s)
  }, p));
}, St = function(t) {
  return /* @__PURE__ */ m(Ft, Object.assign({}, t, {
    className: n("Card__body", t.className)
  }));
}, xt = function(t) {
  return /* @__PURE__ */ m(Mt, Object.assign({}, t, {
    className: n("Card__footer", t.className)
  }));
}, L = /* @__PURE__ */ function(r) {
  return r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r;
}({}), Pt = ["id", "ratio", "orientation", "cardType", "children", "title", "titleProp", "mediaProp", "fullHeight", "disableFullHeight", "alignFooter", "className"], wt = {
  "1/1": "square",
  "16/9": "landscape"
}, a = /* @__PURE__ */ st(function(r, t) {
  var e, i, s = r.id, p = r.ratio, c = p === void 0 ? "1/1" : p, u = r.orientation, g = u === void 0 ? L.VERTICAL : u, y = r.cardType, v = y === void 0 ? "default" : y, D = r.children, q = r.title, F = r.titleProp, _ = F === void 0 ? {
    size: "extraLarge",
    title: "",
    headingLevel: "h1"
  } : F, M = r.mediaProp, N = M === void 0 ? {
    alignment: "left"
  } : M, j = r.fullHeight, K = j === void 0 ? !0 : j, G = r.disableFullHeight, W = G === void 0 ? !K : G, Z = r.alignFooter, J = r.className, Q = T(r, Pt), U = gt({
    label: "Card"
  }), I = lt(null), X = vt(I), Y = ct(), tt = Y.themeName, O = N.alignment === "right", b = g === L.VERTICAL || X.width < (tt === mt.FORD_PRO ? H.laptopMin : H.tabletMin), B = b ? L.VERTICAL : g, o = ht(D, {
    Title: a.Title,
    SubTitle: a.SubTitle,
    Media: a.Media,
    Tags: a.Tag,
    TagGroup: a.TagGroup,
    Footer: a.Footer
  }), $ = pt(function() {
    var x, P, w, ot = R(o.Tags, function(C, nt) {
      return /* @__PURE__ */ m(A, Object.assign({}, C, {
        className: n(["Card__Tag", C.className])
      }), nt);
    }), at = /* @__PURE__ */ m(E, Object.assign({}, (x = o.TagGroup.at(-1)) == null ? void 0 : x.props, {
      _maxTagCount: 5,
      className: n(["Card__TagGroup", (P = o.TagGroup.at(-1)) == null ? void 0 : P.props.className]),
      children: ((w = o.TagGroup.at(-1)) == null ? void 0 : w.props.children) || ot
    })), it = R(o.Media.at(-1), function(C) {
      return /* @__PURE__ */ m(h, Object.assign({}, C, {
        maxHeight: "100%",
        minHeight: "auto",
        width: "100%",
        height: "auto",
        className: n(["Card__Media--" + v, "Card__Media--" + g, C.className]),
        ratio: c
      }));
    });
    return {
      tagGroup: o.Tags.length || o.TagGroup.length ? at : null,
      media: it,
      contents: o.rest
    };
  }, [o, v, g, c]), rt = $.tagGroup, S = $.media, et = $.contents;
  return /* @__PURE__ */ m(yt, Object.assign({}, Q, {
    ref: ut(t, I),
    className: n(["Card__container", J])
  }, U, {
    children: /* @__PURE__ */ z(Nt, {
      id: s,
      className: n(["Card", "Card--" + v, "Card--" + B, "Card--" + N.alignment, !W && "Card--full-height", Z && "Card--align-footer"]),
      children: [(!O || b) && S, /* @__PURE__ */ z(bt, {
        title: q,
        className: n(["Card__content", "Card__content--" + v, "Card__content--" + B, "Card__content--" + wt[c], "Card__content--" + N.alignment]),
        children: [rt, (!!(_ != null && _.title) || !!o.Title.at(-1)) && /* @__PURE__ */ m(k, Object.assign({
          size: _.size,
          headingLevel: _.headingLevel
        }, (e = o.Title.at(-1)) == null ? void 0 : e.props, {
          children: ((i = o.Title.at(-1)) == null ? void 0 : i.props.children) || _.title
        })), o.SubTitle, et, o.Footer]
      }), O && !b && S]
    })
  }));
});
a.Container = Ot;
a.Media = h;
a.Tag = A;
a.Title = k;
a.SubTitle = Bt;
a.TagGroup = E;
a.Body = St;
a.Footer = xt;
export {
  a as Card
};
